import { render, staticRenderFns } from "./create-from-inspiration.vue?vue&type=template&id=e5445750&scoped=true"
import script from "./create-from-inspiration.vue?vue&type=script&setup=true&lang=js"
export * from "./create-from-inspiration.vue?vue&type=script&setup=true&lang=js"
import style0 from "./create-from-inspiration.vue?vue&type=style&index=0&id=e5445750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5445750",
  null
  
)

export default component.exports